import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import Collapse from '@mui/material/Collapse';
import { drawerList } from '../../Data/pageData.jsx';
import { useActiveComponent } from '../ActiveComponentContext.js';
import { useAuth } from '../../contexts/AuthContext/index.jsx';
import AlertDialog from '../AlertDialog';
import { useMediaQuery, useTheme } from '@mui/material';



const TemporaryDrawer = ({ auth, openLoginModal }) => {
  const { activePath, setActivePath } = useActiveComponent();
  const { showAlertDialog, setShowAlertDialog, openDrawer, setOpenDrawer } =
    useAuth();
  const navigate = useNavigate();
  const [expandedItems, setExpandedItems] = React.useState({
    realEstateOpen: false,
    socialCommunitiesOpen: false,
    homeCareOpen: false,
  });

  const resetExpandedItems = () => {
    setExpandedItems({
      realEstateOpen: false,
      socialCommunitiesOpen: false,
      homeCareOpen: false,
    });
  };
 

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
    // Collapse all expanded sub-items when closing the drawer
    if (!newOpen) {
      resetExpandedItems();
    }
  };

  const toggleItem = (item) => () => {
    setExpandedItems((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const handleNavigation = (path) => {
    resetExpandedItems();
    navigate(`/${path}`); // Navigate to the respective path
    setActivePath(`/${path}`);
    setOpenDrawer(false); // Close the drawer after navigating
  };
  const handleCreatePostClick = () => {
    if (auth) {
      handleNavigation('createpost'); // Navigate to the 'create-post' path if auth is signed in
    } else {
      setShowAlertDialog(true); // Show the alert dialog if auth is not signed in
    }
  };

  const handlePostAdClick = () => {
    if (auth) {
      handleNavigation('postad'); // Navigate to the 'create-post' path if auth is signed in
    } else {
      setShowAlertDialog(true); // Show the alert dialog if auth is not signed in
    }
  };

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md')); // breakpoints for where screen size is decided
  const menuIconColor = openDrawer === false ? 'darkslategrey' : 'white';
  const menuIconBackground = openDrawer === false ? 'none' : 'black';
  

  const activeStyles = {
    backgroundColor: 'black',
    color: 'white',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
    },
  };

  const activeIconStyles = {
    color: 'white',
  };


  const DrawerList = (
    <Box sx={{ width: 60 }} role='presentation'>
      <List>
        {drawerList.map((text, index) => {
          // Determine if any sub-item is active
          const isSubItemActive = text.subItems?.some(
            (subItem) => `/${subItem.path}` === activePath
          );

          return (
            <React.Fragment key={text.name}>
              {/* Use React.Fragment with key */}
              <ListItem disablePadding>
                <ListItemButton
                  sx={{
                    p: 0.55,
                    //border:'2px solid red',
                    ...(activePath === `/${text.path}` && activeStyles), // Apply styles if activePath matches
                    '&:hover': {
                      backgroundColor:
                        activePath === `/${text.path}` ? 'black' : 'grey', // Keep active background black on hover
                      color: 'white', // Keep text color white on hover
                    },
                    display: 'flex',
                    flexDirection: 'column', // Stack items vertically
                    justifyContent: 'flex-start',
                    alignItems: 'center', // Center align items
                  }}
                  onClick={
                    text.name === 'Create Post'
                      ? handleCreatePostClick // Handle "Create Post" differently
                      : text.name === 'Post Advertisements'
                      ? handlePostAdClick
                      : text.subItems
                      ? text.name === 'Real Estate'
                        ? toggleItem('realEstateOpen')
                        : toggleItem('socialCommunitiesOpen')
                      : () => handleNavigation(text.path)
                  }
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      p: 0,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        pb: 0,
                        pr: 0,
                        minWidth: 'auto', // Remove default width to fit icon size
                        marginRight: 0, // Remove extra margin on the right
                        ...(activePath === `/${text.path}` && activeIconStyles), // Apply styles if activePath matches
                        '&:hover': {
                          color: 'white', // Keep icon color white on hover
                        },
                      }}
                    >
                      {/* Reduce the size of the icon */}
                      {/* {React.cloneElement(text.icon, { fontSize: isMdUp?'small':'extra-small' })} */}
                      {React.cloneElement(text.icon, { fontSize: 'small' })}

                      {/* {text.icon} */}
                    </ListItemIcon>
                    <ListItemText
                      //primary={text.name}
                      primary={
                        <Typography
                          variant='body2' // You can experiment with other variants if needed
                          sx={{
                            mt: 0,
                            mb: { xs: -0.4, sm: -0.5, md: 0, lg: 0, xl: 0 },
                            fontSize: {
                              xs: '6.5px',
                              sm: '6.5px',
                              md: '7px',
                              lg: '7px',
                              xl: '7px',
                            },
                            textAlign: 'center',               
                          }}
                        >
                          {text.name}
                        </Typography>
                      }
                      sx={{
                        textAlign: 'flex-start', // Center align the text
                        marginTop: {
                          xs: 0.25,
                          sm: 0.5,
                          md: 0.5,
                          lg: 0.5,
                          xl: 0.5,
                        }, // Add some space between the icon and text
                      }}
                    />
                    {text.subItems &&
                      (text.name === 'Real Estate' ? (
                        expandedItems.realEstateOpen ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMoreIcon />
                        )
                      ) : expandedItems.socialCommunitiesOpen ||
                        isSubItemActive ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMoreIcon />
                      ))}
                  </Box>
                </ListItemButton>
              </ListItem>

              {text.subItems && (
                <Collapse
                  in={
                    text.name === 'Real Estate'
                      ? expandedItems.realEstateOpen || isSubItemActive
                      : text.name === 'Social & Communities'
                      ? expandedItems.socialCommunitiesOpen || isSubItemActive
                      : false
                  }
                  timeout='auto'
                  unmountOnExit
                >
                  <List component='div' disablePadding>
                    {text.subItems.map((subItem) => (
                      <ListItem
                        key={subItem.name}
                        disablePadding
                        sx={{ pl: 4 }}
                      >
                        <ListItemButton
                          sx={{
                            ...(activePath === `/${subItem.path}` &&
                              activeStyles), // Apply styles if activePath matches
                            '&:hover': {
                              backgroundColor:
                                activePath === `/${subItem.path}`
                                  ? 'black'
                                  : 'grey', // Keep active background black on hover
                              color: 'white', // Keep text color white on hover
                            },
                          }}
                          onClick={() => handleNavigation(subItem.path)}
                        >
                          <ListItemIcon
                            sx={{
                              ...(activePath === `/${subItem.path}` &&
                                activeIconStyles), // Apply styles if activePath matches
                              '&:hover': {
                                color: 'white', // Keep icon color white on hover
                              },
                            }}
                          >
                            {subItem.icon}
                          </ListItemIcon>
                          <ListItemText primary={subItem.name} />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          );
        })}
      </List>
    </Box>
  );
  return (
    <>
      {openDrawer ? (
        <MenuOpenIcon
          onClick={toggleDrawer(true)}
          sx={{
            boxShadow: '0px 2px 3px grey',
            borderRadius: '10%',
            p: 0.2,
            ml: 1,
            color: menuIconColor,
            backgroundColor: menuIconBackground,
            fontSize: { xs: 28, sm: 28, md: 28, lg: 30, xl: 30 },
            '&:hover': {
              color: 'black',
            },
          }}
        />
      ) : (
        <MenuIcon
          onClick={toggleDrawer(true)}
          sx={{
            ml: 1,
            color: 'darkslategrey',
            backgroundColor: 'none',
            fontSize: { xs: 28, sm: 28, md: 28, lg: 28, xl: 28 },
            '&:hover': {
              color: 'black',
            },
          }}
        />
      )}
      <Drawer
        open={openDrawer}
        onClose={toggleDrawer(false)}
        sx={{
          '& .MuiDrawer-paper': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start', // Align items at the start
            height: 'auto', // Allow height to be determined by content
            maxHeight: '90vh', // Optional: Set a maximum height for the Drawer
            top: '8.5%', // Adjust this value based on your AppBar height
          },
        }}
      >
        {DrawerList}
      </Drawer>
      <AlertDialog
        open={showAlertDialog}
        handleCloseAlert={() => setShowAlertDialog(false)}
      />
    </>
  );
};

export default TemporaryDrawer;
